module.exports = __webpack_public_path__ + "img/s-cross-azul-zafiro.bde56a80.png";